import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass';
import { useHistory } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';

import Loading from 'app/loading';
import StoriesListEmpty from 'app/collection-empty';
import { PrimaryButton } from './components/FtButton';
import { FT_COLORS } from './theme';
import { useFamilyTreeSWR, reorderFamilyMember } from './api';
import { parseFamilyTree } from './helpers';
import MemberGroup from './components/MemberGroup';

// "Family" tab content: grouped, reorderable relatives + add-yourself row.
const FamilyMembersList = ({ journalId, baseRoute, setTotalMember }) => {
  const { push } = useHistory();
  const { data, error, revalidate } = useFamilyTreeSWR(journalId);

  const loading = !data && !error;
  const { groups, members } = parseFamilyTree(data);

  const openMember = (member) => {
    push(`${baseRoute}/members/${member.id}/edit`)
  };

  useEffect(() => {
    setTotalMember(members.length)
  }, [members.length])

  const handleReorder = async (member, position) => {
    try {
      await reorderFamilyMember(journalId, member.id, position);
    } finally {
      revalidate();
    }
  };
  const parentLimitReached = groups.find((group) => group.key === 'parents')?.members?.length >= 4
  return (
    <Box>
      <Text
        fontFamily="Poppins"
        fontWeight={600}
        fontSize="16px"
        color={FT_COLORS.text}
        mb={2}
      >
        Family Members
      </Text>

      {/* Add a family member yourself */}
      <Flex
        as="button"
        type="button"
        alignItems="center"
        width="100%"
        bg="white"
        p={2}
        mb={3}
        onClick={() => push(`${baseRoute}/members/new`)}
        sx={{
          border: '1px dashed',
          borderColor: FT_COLORS.dashedBorder,
          borderRadius: '12px',
          cursor: 'pointer',
          gap: '8px',
          color: FT_COLORS.muted,
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect width="40" height="40" rx="20" fill="#9B59B6" />
          <path d="M40 20C40 25.3043 37.8929 30.3914 34.1421 34.1421C30.3914 37.8929 25.3043 40 20 40C14.6957 40 9.60859 37.8929 5.85786 34.1421C2.10714 30.3914 0 25.3043 0 20C0 14.6957 2.10714 9.60859 5.85786 5.85786C9.60859 2.10714 14.6957 0 20 0C25.3043 0 30.3914 2.10714 34.1421 5.85786C37.8929 9.60859 40 14.6957 40 20ZM21.25 11.25C21.25 10.9185 21.1183 10.6005 20.8839 10.3661C20.6495 10.1317 20.3315 10 20 10C19.6685 10 19.3505 10.1317 19.1161 10.3661C18.8817 10.6005 18.75 10.9185 18.75 11.25V18.75H11.25C10.9185 18.75 10.6005 18.8817 10.3661 19.1161C10.1317 19.3505 10 19.6685 10 20C10 20.3315 10.1317 20.6495 10.3661 20.8839C10.6005 21.1183 10.9185 21.25 11.25 21.25H18.75V28.75C18.75 29.0815 18.8817 29.3995 19.1161 29.6339C19.3505 29.8683 19.6685 30 20 30C20.3315 30 20.6495 29.8683 20.8839 29.6339C21.1183 29.3995 21.25 29.0815 21.25 28.75V21.25H28.75C29.0815 21.25 29.3995 21.1183 29.6339 20.8839C29.8683 20.6495 30 20.3315 30 20C30 19.6685 29.8683 19.3505 29.6339 19.1161C29.3995 18.8817 29.0815 18.75 28.75 18.75H21.25V11.25Z" fill="#F5EEF8" />
        </svg>
        <Text fontFamily="Poppins" fontWeight={500} fontSize="16px" color="#64748B">
          Add a family member yourself
        </Text>
      </Flex>

      {loading && <Loading local />}

      {error && (
        <StoriesListEmpty
          header="We couldn't load your family tree"
          body="Please check your connection and try again."
        >
          <PrimaryButton onClick={() => revalidate()}>Retry</PrimaryButton>
        </StoriesListEmpty>
      )}

      {/* {!loading && !error && members.length === 0 && (
        <StoriesListEmpty
          header="No family members yet"
          body="Add your first family member, or invite family to create their own profiles."
        >
          <PrimaryButton onClick={() => push(`${baseRoute}/members/new`)}>
            Add a family member
          </PrimaryButton>
        </StoriesListEmpty>
      )} */}

      {!loading && !error &&
        groups.map((group) => (
          <MemberGroup
            key={group.key}
            title={group.title}
            members={group.members}
            onOpen={openMember}
            onReorder={handleReorder}
            parentLimitReached={parentLimitReached}
          />
        ))}
    </Box>
  );
};

FamilyMembersList.propTypes = {
  journalId: PropTypes.string.isRequired,
  baseRoute: PropTypes.string.isRequired,
};

export default FamilyMembersList;
